import { render, staticRenderFns } from "./DealBanner.vue?vue&type=template&id=faea7528&scoped=true&"
import script from "./DealBanner.vue?vue&type=script&lang=js&"
export * from "./DealBanner.vue?vue&type=script&lang=js&"
import style0 from "./DealBanner.vue?vue&type=style&index=0&id=faea7528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faea7528",
  null
  
)

export default component.exports